import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useTenantContext } from '@/hooks/useTenantContext';

export type FinancialCheckSeverity = 'critical' | 'warning' | 'info';

export interface FinancialIntegrityCheck {
  key: string;
  label: string;
  severity: FinancialCheckSeverity;
  affected: number;
  amount: number;
  samples: string[];
}

export interface FinancialIntegrityResult {
  generated_at: string;
  company_id: string;
  checks: FinancialIntegrityCheck[];
  critical_count: number;
  warning_count: number;
  ok: boolean;
}

export function useFinancialIntegrityChecks() {
  const { tenantId, hasTenant } = useTenantContext();

  return useQuery({
    queryKey: ['financial-integrity-checks', tenantId],
    queryFn: async (): Promise<FinancialIntegrityResult> => {
      const { data, error } = await supabase.rpc('run_financial_integrity_checks');
      if (error) throw error;
      return data as unknown as FinancialIntegrityResult;
    },
    enabled: hasTenant,
    staleTime: 60_000,
  });
}
